/**
 * Development configuration flags
 * These flags control development-specific behavior and should be disabled in production
 */

import { API_BASE_URL } from '../config';

// Development mode flag
export const DEV_MODE = import.meta.env.MODE === 'development';

// Check if we should use mock data based on environment variable
export const useMockData = import.meta.env.VITE_USE_MOCK_DATA === 'true';

// Dev-only auth bypass: true only when Vite runs in dev (import.meta.env.DEV).
// Production builds have import.meta.env.DEV === false, so this never affects production.
export const BYPASS_AUTH = import.meta.env.DEV === true;

// Set to true to bypass API calls and use mock data in development
export const BYPASS_API = useMockData;

// Log the current configuration (development only — avoid "development.ts" in production console)
if (import.meta.env.DEV) {
  console.log(`[Config] Environment: ${import.meta.env.MODE}`);
  console.log(`[Config] Using mock data: ${useMockData}`);
  console.log(`[Config] API URL: ${API_BASE_URL}`);
} 